"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'historyAdjust',
      searchQuery: {
        brand: '',
        year: null,
        amountType: '',
        currencyType: ''
      },
      apiModule: 'kpiSet'
    };
  },
  computed: {
    domData: function domData() {
      return {
        // amountType: {
        //   label: this.$t('sfe.historyAdjust.amountType'),
        //   valueKey: 'amountType',
        // },
        rsmCode: {
          label: this.$t('sfe.historyAdjust.rsmId'),
          valueKey: 'rsmCode'
        },
        rsmName: {
          label: this.$t('sfe.historyAdjust.rsmName'),
          valueKey: 'rsmName'
        },
        currencyType: {
          label: this.$t('sfe.historyAdjust.currencyType'),
          valueKey: 'currencyType'
        },
        brand: {
          label: this.$t('common.brand'),
          valueKey: 'brand'
        },
        year: {
          label: this.$t('common.year2'),
          valueKey: 'year',
          inputType: 'date',
          type: 'year'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.historyadjust'),
          apiUrl: '/protected/monthlySalesAmountHistory/export'
        },
        import: {
          apiUrl: '/protected/monthlySalesAmountHistory/import'
        }
      };
    },
    tableDom: function tableDom() {
      var month12List = this.createMonth12List();
      return (0, _objectSpread2.default)({
        rsmCode: {
          label: this.$t('sfe.pattenkpi.rsmId')
        },
        rsmName: {
          label: this.$t('sfe.pattenkpi.rsmName')
        },
        region: {
          label: this.$t('sfe.pattenkpi.region')
        },
        brand: {
          label: this.$t('common.brand')
        },
        year: {
          label: this.$t('common.year2')
        },
        amountType: {
          label: this.$t('sfe.historyAdjust.amountType')
        },
        currencyType: {
          label: this.$t('sfe.historyAdjust.currencyType')
        }
      }, month12List);
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/monthlySalesAmountHistory/list'
      };
    }
  },
  methods: {
    createMonth12List: function createMonth12List() {
      var _this = this;
      var month12 = new Array(12).toString().split(',').map(function (t, i) {
        return i + 1;
      });
      var keyPre = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
      var month12List = {};
      month12.forEach(function (m) {
        month12List["".concat(keyPre[m - 1], "SalesTargetQty")] = {
          label: _this.$t("sfe.historyAdjust.amountMonth".concat(m)),
          isCommasNumber: true
        };
      });
      return month12List;
    }
  }
};